import { createSlice } from "@reduxjs/toolkit";
import { getMyExpenseRequestPagination } from "../Service/expenseApi";

const expenseSlice = createSlice({
    name: "expense",
    initialState: {
        isLoading: false,
        expenseList: [],
        myExpense: [],
        expenseById: {},
        expenseReport: [],
        travelReport: [],
        expenseRequestPagination: [],
        expenseSummaryChart: [],
        expenseYearSummaryChart: [],
        txnExpenseById: [],
        currencyList: [],
        dropdownWelfareSubTypeByCode: [],
        dropdownProjectByEmployeeId: [],
        EmployeeWelfareDropdown: [],
        CommonTypeByCode: [],
        createTxnExpense: [],
        createTxnExpenseDraft: [],
        employeeInfo: {}
    },
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setExpenseById(state, action) {
            state.expenseById = action.payload;
        },
        setMyExpense(state, action) {
            state.myExpense = action.payload;
        },
        setExpenseList(state, action) {
            state.expenseList = action.payload;
        },
        setExpenseReport(state, action) {
            state.expenseReport = action.payload;
        },
        setTavelReport(state, action) {
            state.travelReport = action.payload;
        },
        setCurrencyList(state, action) {
            state.currencyList = action.payload;
        },
        setExpenseRequestPagination(state, action) {
            state.expenseRequestPagination = action.payload;
        },
        setExpenseYearSummaryChart(state, action) {
            state.expenseYearSummaryChart = action.payload;
        },
        setExpenseSummaryChart(state, action) {
            state.expenseSummaryChart = action.payload;
        },
        setTxnExpenseById(state, action) {
            state.txnExpenseById = action.payload;
        },
        setDropdownWelfareSubTypeByCode(state, action) {
            state.dropdownWelfareSubTypeByCode = action.payload;
        },
        setdropdownProjectByEmployeeId(state, action) {
            state.dropdownProjectByEmployeeId = action.payload;
        },
        setEmployeeWelfareDropdown(state, action) {
            state.EmployeeWelfareDropdown = action.payload;
        },
        setCommonTypeByCode(state, action) {
            state.CommonTypeByCode = action.payload;
        },
        setcreateTxnExpense(state, action) {
            state.createTxnExpense = action.payload;
        },
        setcreateTxnExpenseDraft(state, action) {
            state.createTxnExpenseDraft = action.payload;
        },
        setEmployeeInfo(state, action) {
            state.employeeInfo = action.payload;
        }
    },
});

export const {
    setIsLoading,
    setExpenseById,
    setExpenseList,
    setMyExpense,
    setExpenseReport,
    setTavelReport,
    setExpenseRequestPagination,
    setExpenseYearSummaryChart,
    setExpenseSummaryChart,
    setTxnExpenseById,
    setCurrencyList,
    setDropdownWelfareSubTypeByCode,
    setdropdownProjectByEmployeeId,
    setEmployeeWelfareDropdown,
    setCommonTypeByCode,
    setcreateTxnExpense,
    setcreateTxnExpenseDraft,
    setEmployeeInfo
} = expenseSlice.actions;
export default expenseSlice.reducer;
